import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const plugin: RouteRecordItem = {
  path: '/plugin',
  name: 'Plugin',
  component: LAYOUT,
  redirect: { name: 'PluginList' },
  meta: {
    orderNo: 12,
    icon: 'mdi:puzzle',
    title: t('routes.plugin.插件管理'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'list',
      name: 'PluginList',
      component: () => import('@/pages/plugin/index.vue'),
      meta: {
        title: t('routes.plugin.插件管理'),
      },
    },
  ],
}

export default plugin
